function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.586 27.414l-10-10a2 2 0 010-2.828l10-10a2 2 0 112.828 2.828L8.828 14H28a2 2 0 110 4H8.828l6.586 6.586c.39.39.586.902.586 1.414s-.195 1.024-.586 1.414a2 2 0 01-2.828 0z"
});

function SvgArrowLeft2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICA8dGl0bGU+YXJyb3ctbGVmdDI8L3RpdGxlPgogIDxwYXRoCiAgICBkPSJNMTIuNTg2IDI3LjQxNGwtMTAtMTBjLTAuNzgxLTAuNzgxLTAuNzgxLTIuMDQ3IDAtMi44MjhsMTAtMTBjMC43ODEtMC43ODEgMi4wNDctMC43ODEgMi44MjggMHMwLjc4MSAyLjA0NyAwIDIuODI4bC02LjU4NiA2LjU4NmgxOS4xNzJjMS4xMDUgMCAyIDAuODk1IDIgMnMtMC44OTUgMi0yIDJoLTE5LjE3Mmw2LjU4NiA2LjU4NmMwLjM5IDAuMzkgMC41ODYgMC45MDIgMC41ODYgMS40MTRzLTAuMTk1IDEuMDI0LTAuNTg2IDEuNDE0Yy0wLjc4MSAwLjc4MS0yLjA0NyAwLjc4MS0yLjgyOCAweiI+PC9wYXRoPgo8L3N2Zz4K";
export { SvgArrowLeft2 as ReactComponent };